<template>
  <span class="mlk-icon" v-html="svgMarkup"></span>
</template>

<script>
import { SVG_PATHS } from './icons.js';

export default {
  name: 'MlkIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 18 },
  },
  computed: {
    svgMarkup() {
      const inner = SVG_PATHS[this.name] || '<circle cx="12" cy="12" r="9"/>';
      return `<svg width="${this.size}" height="${this.size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">${inner}</svg>`;
    },
  },
};
</script>
